import useApiService from 'services/api'
import { CompanyDistributor } from 'models/companies'
import { DistributorsCell } from 'components/FbUI/StagePill'
import { MobileAssignModal } from './MobileAssignModal'
import { ManageTagsDistributorsParams } from 'services/common_table_actions'

interface MobileDistributorAssignModalProps {
  isOpen: boolean
  onClose: () => void
  contactCompanyId: number
  doorProxyId?: number
  isDoorPage?: boolean
  onSuccess?: () => void
}

export function MobileDistributorAssignModal({
  isOpen,
  onClose,
  contactCompanyId,
  doorProxyId,
  isDoorPage = false,
  onSuccess,
}: MobileDistributorAssignModalProps) {
  const api = useApiService()
  const { data: distributors, refetch: refetchDistributors } =
    api.useGetDistributors()

  const apiAction = async (params: ManageTagsDistributorsParams) => {
    const modifiedParams = {
      ...params,
      include_ids: isDoorPage ? [doorProxyId!] : [contactCompanyId],
      exclude_ids: [],
      filter_params: {},
    }
    return api.commonManageDistributors?.({
      values: modifiedParams,
      tableType: isDoorPage ? 'restaurants-bars-doors' : 'companies-table',
    })
  }

  const getSortValue = (
    distributor: CompanyDistributor,
    sortBy: string
  ): string | number | Date => {
    switch (sortBy) {
      case 'name':
        return distributor.name.toLowerCase()
      default:
        return distributor.name.toLowerCase()
    }
  }

  return (
    <MobileAssignModal<CompanyDistributor>
      isOpen={isOpen}
      onClose={onClose}
      title="Assign Distributors"
      subtitle="Select distributors to apply or remove."
      items={distributors || []}
      renderItem={(distributor) => (
        <DistributorsCell
          distributors={[distributor]}
          maxBadges={1}
          nullPlaceholder={<></>}
        />
      )}
      countHeader="Usage"
      apiAction={apiAction}
      itemListKey="distributor_ids"
      onSuccess={onSuccess}
      refetchFn={refetchDistributors}
      getSortValue={getSortValue}
      assignType="distributors"
    />
  )
}
